import {
  IndexmodelComponentMainDiv,
  IndexmodelComponentModleContainer,
} from "../../styles/indexcomponentsstyles/indexmodelcomponentstyles";
import { ReactComponent as OpenAI } from "./assets/openai-brands-solid-full.svg";
const IndexModelComponent = () => {

 
  return (
    <IndexmodelComponentMainDiv>
      <div>
        <div className="gradient-background">
          <div className="model-icon-container ">
            <div className="model-icon-holder">
              {Icons.map((item, index) => (
                <IndexmodelComponentModleContainer
                  key={index + "model"}
                >
                  <div className="model-container">
                    <div>
                       <div className=" ring">
                        <OpenAI className="icon" />
                    </div>

                    </div>
                   
                  </div>
                </IndexmodelComponentModleContainer>
              ))}
            </div>
          </div>
        </div>
      </div>
    </IndexmodelComponentMainDiv>
  );
};
const Icons = ["b", "b", "b", "b", "b",];
export default IndexModelComponent;
